class FourOThreeController {}

export default FourOThreeController;



// WEBPACK FOOTER //
// ./client/app/four-o-three/four-o-three.controller.js